import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  AddPage,
  ViewPage,
} from './pages';

const ProductsPage = (): JSX.Element => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.products.add.root}`} component={AddPage} />
      <Route path={`${path}`} component={ViewPage} />
    </Switch>
  );
};

export default ProductsPage;
